import script from "./ModalAddInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAddInvoice.vue?vue&type=script&setup=true&lang=js"

import "./ModalAddInvoice.vue?vue&type=style&index=0&id=ed1a51ea&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed1a51ea"]])

export default __exports__